import { TransTenantSpecific } from '@/i18n/trans/tenantSpecific';
import type { TravelClass } from '@/utils/purchase';
import {
  ToggleGroup,
  type ToggleGroupOption,
} from '@packages/webshop-design-system';
import type { FC } from 'react';

interface TravelClassTabsProps {
  tabs: ReadonlyArray<TravelClass>;
  legId: string;
  /** Already resolved to one of `tabs` by the caller */
  value?: TravelClass;
  onChange: (legId: string, travelClass: TravelClass) => void;
}

const TravelClassTabs: FC<TravelClassTabsProps> = ({
  tabs,
  legId,
  value,
  onChange,
}) => {
  if (tabs.length < 2) {
    return null;
  }

  const options: Array<ToggleGroupOption> = tabs.map((travelClass) => ({
    value: travelClass,
    label: <TransTenantSpecific i18nKey={travelClass} />,
  }));

  return (
    <ToggleGroup
      data-testid="travel-class-tabs"
      value={value}
      onValueChange={(value) => {
        const next = tabs.find((tab) => tab === value);
        if (next) {
          onChange(legId, next);
        }
      }}
      options={options}
    />
  );
};

export default TravelClassTabs;
